import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Trello: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', ry: '2' }],
    ['rect', { width: '3', height: '9', x: '7', y: '7' }],
    ['rect', { width: '3', height: '5', x: '14', y: '7' }],
  ],
];

export default Trello;
